export const iconFontAwesomeGamingTwitch = (
	<i className="fa-solid fa-twitch"></i>
);
